<template>
    <base-nav
        v-model="showMenu"
        :class="$style.topNavbar"
        class="navbar-absolute"
        type="white"
        :transparent="true"
    >
        <div slot="brand" class="navbar-wrapper">
            <div class="navbar-minimize d-inline">
                <sidebar-toggle-button />
            </div>
            <div
                class="navbar-toggle d-inline"
                :class="{ toggled: $sidebar.showSidebar }"
            >
                <button
                    type="button"
                    class="navbar-toggler"
                    @click="toggleSidebar"
                >
                    <span class="navbar-toggler-bar bar1" />
                    <span class="navbar-toggler-bar bar2" />
                    <span class="navbar-toggler-bar bar3" />
                </button>
            </div>
        </div>
        <div :class="$style.navbarContents">
            <div class="col-md-12" :class="$style.navbarTitleContainer">
                <h1 class="mb-0">
                    {{ store.navbarTitle }}
                </h1>
                <h4
                    v-if="store.navbarSubtitle"
                    class="mb-0"
                    :class="$style.subtitle"
                >
                    {{ store.navbarSubtitle }}
                </h4>
            </div>
            <base-alert
                v-if="deliveryRequestCustomer && !deliveryRequestModalVisible"
                :class="$style.deliveryRequestNotification"
                type="info"
                @click.native="$emit('showDeliveryRequestModal')"
            >
                Pending delivery request for
                <strong>{{ deliveryRequestCustomer }}</strong>
            </base-alert>
        </div>
        <ul class="navbar-nav">
            <!-- <div class="search-bar input-group">
          <input type="text" v-model="searchQuery" class="form-control nav-search-input"
            placeholder="Search projects or tasks..."
          >
          <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>
      </div> -->
            <base-dropdown
                tag="li"
                :menu-on-right="true"
                title-tag="a"
                class="nav-item"
                title-classes="nav-link"
                menu-classes="dropdown-navbar"
            >
                <template slot="title">
                    <avatar
                        :username="fullName"
                        background-color="#aaa"
                        :size="30"
                        color="white"
                    />
                    <b class="caret d-none d-lg-block d-xl-block" />
                </template>
                <li>
                    <p :class="$style.accountName">{{ fullName }}</p>
                </li>
                <router-link class="nav-link" tag="li" to="/account">
                    <a class="nav-item dropdown-item">My Account</a>
                </router-link>
                <div class="dropdown-divider" />
                <li v-if="hasAlternateAccounts" class="nav-link">
                    <a
                        id="switchAccount"
                        class="nav-item dropdown-item"
                        @click="showAccountSwitchModal = true"
                    >
                        Switch Account
                    </a>
                </li>
                <li class="nav-link">
                    <a
                        id="logoutLink"
                        class="nav-item dropdown-item"
                        @click="logout"
                    >
                        Log out
                    </a>
                </li>
            </base-dropdown>
        </ul>
        <modal
            :show="showAccountSwitchModal"
            body-classes="p-0"
            modal-classes="modal-md"
        >
            <card class="card-form mb-0">
                <template slot="header">
                    <h2 class="modal-title">Switch Account</h2>
                    <button
                        type="button"
                        class="close"
                        aria-label="Close"
                        @click="showAccountSwitchModal = false"
                    >
                        <i class="tim-icons icon-simple-remove" />
                    </button>
                </template>
                <div :class="$style.summary">
                    <h4>Current account</h4>
                    <h4>{{ currentAccountDisplayName }}</h4>
                </div>
                <el-radio-group
                    v-model="selectedAccountId"
                    :class="$style.radio"
                    size="medium"
                >
                    <el-radio
                        v-for="account in me.alternate_accounts"
                        :key="account.id"
                        :label="account.id"
                        border
                    >
                        {{ accountDisplayName(account) }}
                    </el-radio>
                </el-radio-group>
                <base-button
                    block
                    type="primary"
                    class="btn-fill mt-4"
                    @click="$emit('switchAccount', selectedAccountId)"
                >
                    Switch Account
                </base-button>
            </card>
        </modal>
    </base-nav>
</template>

<script>
import { Radio, RadioGroup } from "element-ui";
import Avatar from "vue-avatar";
import { BaseNav, Modal, BaseAlert } from "src/components/UI";
import SidebarToggleButton from "./SidebarToggleButton";
import { store } from "src/global-store.js";

export default {
    components: {
        SidebarToggleButton,
        BaseNav,
        Modal,
        Avatar,
        BaseAlert,
        [Radio.name]: Radio,
        [RadioGroup.name]: RadioGroup,
    },
    props: {
        me: {
            type: Object,
            required: true,
        },
        deliveryRequestCustomer: {
            type: String,
            required: true,
        },
        deliveryRequestModalVisible: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            selectedAccountId: "",
            showAccountSwitchModal: false,
            showMenu: false,
        };
    },
    computed: {
        store() {
            return store;
        },
        fullName() {
            return this.me.first_name + " " + this.me.last_name;
        },
        hasAlternateAccounts() {
            return this.me.alternate_accounts?.length;
        },
        currentAccountDisplayName() {
            let displayName = `${this.fullName} (${this.me.role})`;
            if (this.me.customer_name) {
                displayName = this.me.customer_name;
                if (this.me.designer_name) {
                    displayName += ` (${this.me.designer_name})`;
                }
            }
            return displayName;
        },
    },
    methods: {
        accountDisplayName(account) {
            let displayName = `${account.first_name} ${account.last_name} (${account.role})`;
            if (account.customer_name) {
                displayName = account.customer_name;
                if (account.designer_name) {
                    displayName += ` (${account.designer_name})`;
                }
            }
            return displayName;
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        logout() {
            this.$emit("logout");
        },
    },
};
</script>

<style module>
.navbarTitleContainer {
    padding-left: 42px;
}
.subtitle {
    color: gray;
}
.topNavbar {
    top: 0px;
}
.accountName {
    font-weight: 600;
    color: black;
    cursor: default;
}
.navbarContents {
    display: flex;
    flex-grow: 1;
    justify-content: center;
}
.deliveryRequestNotification {
    margin: 0px;
    cursor: pointer;
}
.summary {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}
.summary h4:last-of-type {
    color: #666;
}
.radio {
    width: 100%;
}
.radio label {
    width: 100%;
    margin-left: 0px !important;
    margin-right: 0px !important;
    text-transform: none !important;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
